import React from 'react';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

interface RecurrenceTypeSelectorProps {
  recurrenceType: 'weekly' | 'monthly';
  onChange: (type: 'weekly' | 'monthly') => void;
}

const RecurrenceTypeSelector: React.FC<RecurrenceTypeSelectorProps> = ({
  recurrenceType,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as 'weekly' | 'monthly');
  };

  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>
        Recurrence pattern
      </Typography>
      <FormControl component="fieldset">
        <RadioGroup value={recurrenceType} onChange={handleChange}>
          <FormControlLabel
            value="weekly"
            control={<Radio size="small" />}
            label={<Typography variant="body2">Day(s) of the week</Typography>}
          />
          <FormControlLabel
            value="monthly"
            control={<Radio size="small" />}
            label={<Typography variant="body2">Day(s) of the month</Typography>}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default RecurrenceTypeSelector;
